module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/banner/th-043d6474a4544eb0eecaf5e91227e8e9.jpg";